import { merge } from './utils';
import { TusOptions } from './types';
import { TUS_SENDER_DEFAULT_OPTIONS } from './defaults';

const getMandatoryTusOptions = (options?: TusOptions): TusOptions =>
  merge({} as TusOptions, TUS_SENDER_DEFAULT_OPTIONS, options!);

export { getMandatoryTusOptions };
